import { gql } from "@apollo/client";

export const GET_CONSUMER_CUSTOMER_BY_APPLICANT_ID = gql`
  query consumerGetCustomerByApplicantId($applicantId: String!) {
    consumerGetCustomerByApplicantId(applicantId: $applicantId) {
      id
      identityVerification {
        provider
        applicantId
        workflowRunId
        status
      }
    }
  }
`;
